"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SignalR = require("@microsoft/signalr");
var AuthenticationService_1 = require("./AuthenticationService");
var EventHandlerService_1 = require("../Services/EventHandlerService");
var Types_1 = require("../Types");
var NotificationHandlerService_1 = require("./NotificationHandlerService");
var SignalREventHandler = /** @class */ (function () {
    function SignalREventHandler(methodName, action) {
        var _this = this;
        this.MethodName = function () { return _this._methodName; };
        this.Action = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this._action(args);
        };
        this._methodName = methodName;
        this._action = action;
    }
    return SignalREventHandler;
}());
var ConnectionService = /** @class */ (function () {
    function ConnectionService() {
        var _this = this;
        this.changeQueuedItemsCount = {};
        this.nbsConnectionOffline = {};
        this.nbsConnectionOnline = {};
        this.userUpdated = {};
        this.passwordResetInitiated = {};
        this.arvatoNotification = {};
        this.init = function (auth, callback, queueChangeCallback, connectionStateChangeCallback, stateChangeCallback, resources) {
            if (_this.initialised) {
                return;
            }
            _this.alreadyLoggedIn = new SignalREventHandler("AlreadyLoggedIn", function () {
                console.error("Already logged in");
                _this._isAlreadyLoggedIn = true;
                AuthenticationService_1.Auth.setError();
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteErrorEvent(resources.AlreadyLoggedIn, resources.LoginFailed, [
                    new Types_1.VeriLiteEventAction(resources.LogOut, "secondary", function (currentEvent, closeModalCallback) {
                        _this.authInstance.logout();
                    })
                ]));
            });
            _this.onConnectionStateChange = function (newState) {
                //console.log(`[${(new Date()).toISOString()}] SignalR is now ${newState.toString()}`);
                connectionStateChangeCallback(newState);
            };
            _this.connectionCallback = callback;
            _this.authInstance = auth;
            _this.connection = new SignalR.HubConnectionBuilder()
                .withUrl("/connection", { accessTokenFactory: auth.getAccessToken })
                .withAutomaticReconnect()
                .build();
            _this.changeQueuedItemsCount = new SignalREventHandler("ChangeQueuedItemsCount", function (isStoreAndForward) {
                queueChangeCallback(("" + isStoreAndForward).toLowerCase() == 'true');
            });
            _this.nbsConnectionOffline = new SignalREventHandler("CloseConnection", function () {
                //console.log(`[${(new Date()).toISOString()}] nbs offline`);
                stateChangeCallback(false);
            });
            _this.nbsConnectionOnline = new SignalREventHandler("ApplyConnection", function () {
                //console.log(`[${(new Date()).toISOString()}] nbs online`);
                stateChangeCallback(true);
            });
            _this.userUpdated = new SignalREventHandler("UserUpdated", function () {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteWarningEvent(resources.UserUpdatedMessage, resources.UserUpdatedTitle, [
                    new Types_1.VeriLiteEventAction(resources.ReAuthNow, "primary", function (currentEvent, closeModalCallback) {
                        _this.authInstance.logout();
                    }), new Types_1.VeriLiteEventAction(resources.ReAuthLater, "secondary", function (currentEvent, closeModalCallback) {
                        closeModalCallback();
                    })
                ]));
            });
            _this.passwordResetInitiated = new SignalREventHandler("PasswordResetInitiated", function () {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteWarningEvent(resources.ResetPasswordInitiatedMessage, resources.ResetPasswordInitiatedTitle, [
                    new Types_1.VeriLiteEventAction(resources.ReAuthNow, "primary", function (currentEvent, closeModalCallback) {
                        _this.authInstance.logout();
                    })
                ]));
            });
            _this.arvatoNotification = new SignalREventHandler("ArvatoNotificationRecieved", function (notification) {
                NotificationHandlerService_1.NotificationHandlerProvider.GetInstance().AddNotification(notification[0]);
            });
            _this.assignEventHandler(_this.changeQueuedItemsCount);
            _this.assignEventHandler(_this.nbsConnectionOffline);
            _this.assignEventHandler(_this.nbsConnectionOnline);
            _this.assignEventHandler(_this.alreadyLoggedIn);
            _this.assignEventHandler(new SignalREventHandler("LicenseError", function () { return AuthenticationService_1.Auth.setLicenseError(); }));
            _this.assignEventHandler(_this.userUpdated);
            _this.assignEventHandler(_this.passwordResetInitiated);
            _this.assignEventHandler(_this.arvatoNotification);
            _this.connection.onclose(function (error) {
                var _a;
                _this.onConnectionStateChange(((_a = _this.connection) === null || _a === void 0 ? void 0 : _a.state) || SignalR.HubConnectionState.Disconnected);
                //console.log(`[${(new Date()).toISOString()}] SignalR OnClose: ${this.connection?.state.toString()}`);
                if (error) {
                    console.error(error);
                }
            });
            _this.connection.onreconnected(function (connectionId) {
                var _a;
                _this.onConnectionStateChange(((_a = _this.connection) === null || _a === void 0 ? void 0 : _a.state) || SignalR.HubConnectionState.Disconnected);
                //console.log(`[${(new Date()).toISOString()}] SignalR OnReconnected(${connectionId ? connectionId : "no connection id available"}): ${this.connection?.state.toString()}`);
            });
            _this.connection.onreconnecting(function (error) {
                var _a;
                _this.onConnectionStateChange(((_a = _this.connection) === null || _a === void 0 ? void 0 : _a.state) || SignalR.HubConnectionState.Disconnected);
                //console.log(`[${(new Date()).toISOString()}] SignalR OnReconnencting: ${this.connection?.state.toString()}`);
                if (error) {
                    console.error(error);
                }
            });
            _this.startConnection();
        };
        this.startConnection = function (shouldRetry) {
            if (shouldRetry === void 0) { shouldRetry = true; }
            var _a, _b;
            var startDate = Date.now();
            try {
                (_a = _this.connection) === null || _a === void 0 ? void 0 : _a.start().then(function () {
                    var _a, _b;
                    var d = Date.now() - startDate;
                    //useful log
                    //console.log(`[${(new Date()).toISOString()}] SignalR Connected: time taken: ${d / 1000} seconds`);
                    _this.onConnectionStateChange(((_a = _this.connection) === null || _a === void 0 ? void 0 : _a.state) || SignalR.HubConnectionState.Disconnected);
                    if (!_this.initialised) {
                        _this.initialised = true;
                        _this.connectionCallback(((_b = _this.connection) === null || _b === void 0 ? void 0 : _b.state) == SignalR.HubConnectionState.Connected);
                    }
                }).catch(function (err) {
                    var _a;
                    _this.onConnectionStateChange(((_a = _this.connection) === null || _a === void 0 ? void 0 : _a.state) || SignalR.HubConnectionState.Disconnected);
                    //console.log("Start Promise Catch");
                    console.error(err);
                    //console.log(`should retry? ${shouldRetry}`)
                    if (shouldRetry) {
                        //console.log("try again straight away, just in case");
                        _this.startConnection(false);
                    }
                });
            }
            catch (e) {
                _this.onConnectionStateChange(((_b = _this.connection) === null || _b === void 0 ? void 0 : _b.state) || SignalR.HubConnectionState.Disconnected);
                //console.log("Connection Try Catch");
            }
        };
        this.syncConnection = function (organisation, location) {
            var _a;
            (_a = _this.connection) === null || _a === void 0 ? void 0 : _a.send("syncConnectionAsync", organisation, location);
        };
        this.assignEventHandler = function (eventHandler) {
            _this.connection.on(eventHandler.MethodName(), eventHandler.Action);
        };
        this.initialised = false;
        this._isAlreadyLoggedIn = false;
        this.authInstance = null; //this is set in init
        this.alreadyLoggedIn = {};
        this.onConnectionStateChange = function () { console.error("onConnectionStateChanged not initilised yet!"); };
        this.connectionCallback = function () { console.error("connectionCallback not initilised yet!"); };
    }
    Object.defineProperty(ConnectionService.prototype, "isConnected", {
        get: function () {
            return this.initialised;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectionService.prototype, "isAlreadyLoggedIn", {
        get: function () {
            return this._isAlreadyLoggedIn;
        },
        enumerable: true,
        configurable: true
    });
    return ConnectionService;
}());
exports.SignalRConnection = new ConnectionService();
//# sourceMappingURL=ConnectionService.js.map